import axios from 'axios';

class AuthService {
    login(user) {
        return axios
            .post('/auth', {
                email: user.email,
                password: user.password
            })
            .then(response => {
                if (response.data.token){
                    localStorage.setItem('user-token', response.data.token);
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.token;
                }

                return response.data;
            });     
    }

    logout() {
        localStorage.removeItem('user-token');
        delete axios.defaults.headers.common['Authorization'];
    }

    register(user) {
        return axios.post('/users', {
          username: user.username,
          email: user.email,
          password: user.password
        });
    }   
} 

export default new AuthService();